import { defineMessages } from 'react-intl';

export default defineMessages({
  'Пошук легкових': {
    id: 'endpade:search:title',
    defaultMessage: 'Пошук легкових',
  },
  Легкові: {
    id: 'search:seo:title',
    defaultMessage: 'Легкові',
  },
  'Продаж авто в Україні. Найсвіжіші оголошення. Купити чи продати Б/В авто вигідніше з Avtoprod.ua': {
    id: 'search:seo:description',
    defaultMessage: 'Легкові',
  },
  'Продаж {car}, {location}, ціна {price} {currency} (id {id})': {
    id: 'endpade:seo:title',
    defaultMessage:
      'Продаж {car}, {location}, ціна {price} {currency} (id {id})',
  },
});
